const Backbone = window.Backbone;

const fs = require('fs');
const path = require('path');
const TitleCardTemplate = fs.readFileSync(path.join(__dirname, 'templates/TitleCardListView.html'), 'utf8');

import TitleInfoListView from './views/TitleInfoListView';
import TitleActionButton from './TitleActionButton';
import WishListButton from './WishListButton';
import TitleHeaderBar from './TitleHeaderBar';
import Cover from './Cover';
import TitleDescription from './views/TitleDescription.js';

const TitleCardListView = Backbone.View.extend({

    className: 'title-container',

    template: _.template(TitleCardTemplate),

    initialize({bus, coverWidths}) {
        const model = this.model;

        const $tmp = $(this.template());

        this.titleHeaderBar = new TitleHeaderBar({
            model, el: $tmp.find('.TitleHeaderBar')
        });

        this.cover = new Cover({
            model, el: $tmp.find('.CoverImage'), coverWidths, isInHero: false
        });

        this.titleInfo = new TitleInfoListView({
            model, el: $tmp.find('.TitleInfo')
        });

        this.titleActionButton = new TitleActionButton({
            model, el: $tmp.find('.TitleAction'), type: 'button', style: 'fill'
        });

        if (!window.featureManager.isEnabled('internationalDemoMode')){
            this.wishlistButton = new WishListButton({
                model, el: $tmp.find('.TitleWishlist'), type: 'with-text'
            }).render();
        }

        this.titleDescription = new TitleDescription({
            model, el: $tmp.find('.title-description')
        });

        this.$el.html($tmp);
    }
});

module.exports = TitleCardListView;
